import { render } from "./FormatHeader2.vue?vue&type=template&id=2b747fe4"
import script from "./FormatHeader2.vue?vue&type=script&lang=js"
export * from "./FormatHeader2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__